import Hero from './components/Hero';
import VerificationCTA from './components/VerificationCTA';
import WhyVerify from './components/WhyVerify';
import CertificationProcess from './components/CertificationProcess';
import LiveStats from './components/LiveStats';
import FAQ from './components/FAQ';
import CorporateGovernance from './components/CorporateGovernance';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Inter', 'Montserrat', sans-serif" }}>
      {/* 1. Hero — Geneva Financial District panoramic */}
      <Hero />
      {/* 2. Institutional ERC-20 Asset Audit Portal — first section, high contrast */}
      <VerificationCTA />
      {/* 3. The Value of the BPI Compliance Certificate — 4 premium tiles */}
      <WhyVerify />
      {/* 4. The 5-Minute Certification Process — step-by-step */}
      <CertificationProcess />
      {/* 5. Live Platform Statistics */}
      <LiveStats />
      {/* 6. Professional FAQ — Accordion */}
      <FAQ />
      {/* 7. Corporate Governance — BPI Holding SA Geneva */}
      <CorporateGovernance />
      {/* 8. Footer */}
      <Footer />
    </div>
  );
}
